import Peer from "simple-peer";

// ICE servers from the same env variables the session player uses
export function iceServers() {
  const servers = [];
  if (process.env.VUE_APP_STUN_ICE_SERVER) {
    servers.push({ urls: process.env.VUE_APP_STUN_ICE_SERVER });
  }
  if (process.env.VUE_APP_TURN_ICE_SERVER) {
    servers.push({
      urls: process.env.VUE_APP_TURN_ICE_SERVER,
      username: process.env.VUE_APP_STUN_ICE_SERVER_L,
      credential: process.env.VUE_APP_STUN_ICE_SERVER_P,
    });
  }
  if (!servers.length) {
    servers.push({ urls: "stun:stun.l.google.com:19302" });
  }
  return servers;
}

export function getLocalStream() {
  const constraints = {
    audio: { echoCancellation: true, noiseSuppression: true },
    video: { width: { ideal: 1280 }, height: { ideal: 720 }, facingMode: "user" },
  };

  return navigator.mediaDevices
    .getUserMedia(constraints)
    .catch(() => navigator.mediaDevices.getUserMedia({ audio: true, video: false }));
}

export function randomId() {
  if (window.crypto && window.crypto.randomUUID) {
    return window.crypto.randomUUID();
  }
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    (c ^ (window.crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))).toString(16)
  );
}

/**
 * One peer connection with the other side of the room.
 * Signals go through the API: send(payload) pushes, handle(payload) is fed from polling.
 */
export class RoomPeer {
  constructor({ initiator, stream, send, onStream, onConnect, onClose }) {
    this.closed = false;
    // signals are posted one by one: the other side must get the offer before its candidates
    this.sendQueue = Promise.resolve();
    this.peer = new Peer({
      initiator,
      stream,
      trickle: true,
      config: { iceServers: iceServers() },
    });

    this.peer.on("signal", (data) => {
      if (this.closed) return;
      this.sendQueue = this.sendQueue.then(() => (this.closed ? null : send(data))).catch(() => {});
    });
    this.peer.on("stream", (remote) => onStream && onStream(remote));
    this.peer.on("connect", () => onConnect && onConnect());
    this.peer.on("close", () => this.finish(onClose));
    this.peer.on("error", (err) => {
      console.warn("RoomPeer error", err && (err.code || err.message));
      this.finish(onClose);
    });
  }

  handle(payload) {
    if (this.closed) return;
    try {
      this.peer.signal(payload);
    } catch (e) {
      // late candidates for a destroyed connection
    }
  }

  finish(callback) {
    if (this.closed) return;
    this.closed = true;
    callback && callback();
  }

  destroy() {
    this.closed = true;
    try {
      this.peer.destroy();
    } catch (e) {
      // already destroyed
    }
  }
}

/** Signals that only move control state, not WebRTC data */
export const CONTROL_TYPES = ["guest_joined", "guest_left", "kicked"];
